import { ArrowBackIos, ArrowForwardIos, Delete} from "@mui/icons-material";
import { FormatTimePassedUtc, sanitizeText } from "../newComponents/GeneralClasses";
import { HbrArrowLeft, HbrArrowRight, HbrAvatarProfile, HbrBrushIcon, HbrCancel, HbrCommentIcon, HbrFlagReport, HbrForwardIcon, HbrIconFileCopy, HbrMoreHorizontal, HbrPlayButton, HbrShareIcon, HbrSoundOff, HbrSoundOn, HbrStopPlayback } from "../newComponents/Mycustomsvgicons";
import TextShortener from "../TextShortener";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useCallback, useContext, useEffect, useReducer, useRef, useState } from "react";
import { collection, deleteDoc, doc, getDoc, getDocs, limit, orderBy, query } from "firebase/firestore";
import db, { realTimeDB, storage } from "../firebase";
import { ref as storageRef } from "firebase/storage";
import { actionConsts, reducer } from "../newComponents/StateManager";
import UseLayout from "../newComponents/useLayout";
import { AuthContext } from "../AuthContext";
import appIcon from "../otherImg/hbrlitenewicon.png";
import { get, onValue, ref, remove, set } from "firebase/database";
import { getEdifiedStateDB, getViewsDB, initDB, trackEdifiedStateDB, trackshortViewsDB } from "../ConfigureIndexDB";
import { deleteObject } from "firebase/storage";
import { CustomAlertDialog } from "../newComponents/CustomAlertDialog";
import ReactPlayer from "react-player";
import edifiedBtn from "../otherImg/newedifiedwhite.png";
import edifiedred from "../otherImg/newedifiedred.png";


const ShortVideoPlayer = () => {

    const [videoUrl,setVideoUrl]=useState({vid:"",i:0,profilepic:"",desc:"",name:"",shortsid:"",vidDate:"",email:""});
    const [playing,setPlaying]=useState(true);
    const [buffering,setBuffering]=useState(false);
    const {profile_pic} = useContext(AuthContext);
    const {user_email} = useContext(AuthContext);
    const [edified,setEdified]=useState(false);
    const [views,setViews]=useState(0);
    const [likes,setLikes]=useState(0);
    const [shareCount, setShareCount] = useState(0);
    const [share,setShare]=useState(false);
    const [copied,setCopied]=useState(false);
    const [openMenu,setOpenMenu]=useState(false);
    const [videos, setVideos]=useState([]);
    const [state,dispatch]=useReducer(reducer,{progressIndicator: false, alertMessage: "", showAlert: false, mute: true});
    const navigate = useNavigate();
    const location = useLocation();
    const closeMenuRef = useRef(null);
    const closeShareRef = useRef(null);
    const {width}=UseLayout();
    const {id} = useParams();

    const getUserPic=(user_ref)=>{
        return new Promise((resolve,reject) => {
            onValue(ref(realTimeDB,`${process.env.REACT_APP_USERS}/${sanitizeText(user_ref)}/profile_pic`),(snapshot)=>{
                if (snapshot.exists()) {
                    resolve(snapshot.val());
                }else{
                    resolve("");
                }
            },(error)=>{
                reject("");
            });
        });
    };
    const getUserName=(user_ref)=>{
        return new Promise((resolve,reject) => {
            onValue(ref(realTimeDB,`${process.env.REACT_APP_USERS}/${sanitizeText(user_ref)}/userName`),(snapshot)=>{
                if (snapshot.exists()) {
                    resolve(snapshot.val());
                }else{
                    resolve("");
                }
            },(error)=>{
                reject("");
            });
        });
    };

    useEffect(()=>{
        const docRef = doc(db,"shorts",id);
        getDoc(docRef).then(async(snapshot)=>{
          if (snapshot.exists()) {
            const videoSnapshot = snapshot.data();
            const shortsid = videoSnapshot?.shorts_id;
            const nameonpost = await getUserName(videoSnapshot?.shorts_email);
            const piconpost = await getUserPic(videoSnapshot?.shorts_email);

            setVideoUrl({
                i: -1,
                profilepic: piconpost,
                name: nameonpost !== "" ? nameonpost : videoSnapshot.shorts_name,
                desc: videoSnapshot.shorts_desc,
                shortsid: videoSnapshot.shorts_id,
                vidDate: videoSnapshot.timestamp,
                email: videoSnapshot.shorts_email,
                vid: videoSnapshot.shorts_vid
            });
    
            const likesSnapshot = await get(ref(realTimeDB,`shortsVideos/${shortsid}/edified`));
            if(likesSnapshot.exists()){
                setLikes(likesSnapshot.val());
            }
    
            const viewsSnapshot = await get(ref(realTimeDB,`shortsVideos/${shortsid}/views`));
            if(viewsSnapshot.exists()){
                setViews(viewsSnapshot.val());
            }
    
            const shareSnapshot = await get(ref(realTimeDB,`shortsVideos/${shortsid}/shares`));
            if(shareSnapshot.exists()){
                setShareCount(shareSnapshot.val());
            }
            handleEdifiedState(shortsid);
            handleShortVidViews(shortsid);
          }  
        }).catch((err)=>{

        });
    },[id]);

    useEffect(()=>{
        const collectionref = collection(db,"shorts");
        const q = query(collectionref,orderBy('timestamp','desc'),limit(70));
        getDocs(q).then((snapshot)=>{
            const shortVideos = [];
            snapshot.forEach((doc)=>{
                shortVideos.push(doc.data());
            });
            const filterVideos = shortVideos.filter(shortsId => shortsId.shorts_id !== id);
           setVideos(filterVideos);
        }).catch((err)=>{
            console.log(err);
        })
    },[id]);
    // const videos = useMemo(()=>videos, [videos]);

    const handleChangeVideo=async(actionType)=>{
        let index = videoUrl.i;
        if(actionType === "next"){
            let lastVideo = index === videos.length - 1;
            const nextVid = lastVideo ? 0 : index + 1;
            const nameonpost = await getUserName(videos[nextVid].shorts_email);
            const piconpost = await getUserPic(videos[nextVid].shorts_email);
            setVideoUrl({
                i: nextVid,
                profilepic: piconpost && piconpost,
                desc: videos[nextVid].shorts_desc,
                name: nameonpost && nameonpost !== "" ? nameonpost : videos[nextVid].shorts_name,
                shortsid: videos[nextVid].shorts_id,
                vidDate: videos[nextVid].timestamp,
                email: videos[nextVid].shorts_email,
                vid: videos[nextVid].shorts_vid
            });
            // if (nameonpost) {
             
            // }
    
            onValue(ref(realTimeDB,`shortsVideos/${videos[nextVid].shorts_id}/edified`),(snapshot)=>{
                if(snapshot.exists()){
                    setLikes(snapshot.val());
                }else{
                    setLikes(0);
                }
            });
    
          
          onValue(ref(realTimeDB,`shortsVideos/${videos[nextVid].shorts_id}/views`),(snapshot)=>{
                if(snapshot.exists()){
                    setViews(snapshot.val());
                }
          });

          onValue(ref(realTimeDB,`shortsVideos/${videos[nextVid].shorts_id}/shares`),(snapshot)=>{
                if(snapshot.exists()){
                    setShareCount(snapshot.val());
                }
          });

          handleEdifiedState(videos[nextVid].shorts_id);
          handleShortVidViews(videos[nextVid].shorts_id);

        } else if(actionType === "prev"){
            let firstVideo = index === 0;
            const prevVideo = firstVideo ? videos.length -1 : index - 1;
            const nameonpost = await getUserName(videos[prevVideo].shorts_email);
            const piconpost = await getUserPic(videos[prevVideo].shorts_email);
            if (nameonpost) {
                setVideoUrl({
                    i: prevVideo,
                    profilepic: piconpost,
                    desc: videos[prevVideo].shorts_desc,
                    name: nameonpost !== "" ? nameonpost : videos[prevVideo].shorts_name,
                    shortsid: videos[prevVideo].shorts_id,
                    vidDate: videos[prevVideo].timestamp,
                    email: videos[prevVideo].shorts_email,
                    vid: videos[prevVideo].shorts_vid
                });            
            }
    
            onValue(ref(realTimeDB,`shortsVideos/${videos[prevVideo].shorts_id}/edified`),(snapshot)=>{
                if(snapshot.exists()){
                    setLikes(snapshot.val());
                }else{
                    setLikes(0);
                }
          });
    
          onValue(ref(realTimeDB,`shortsVideos/${videos[prevVideo].shorts_id}/views`),(snapshot)=>{
                if(snapshot.exists()){
                    setViews(snapshot.val());
                }
          });

          onValue(ref(realTimeDB,`shortsVideos/${videos[prevVideo].shorts_id}/shares`),(snapshot)=>{
                if(snapshot.exists()){
                    setShareCount(snapshot.val());
                }
          });

          handleEdifiedState(videos[prevVideo].shorts_id);
          handleShortVidViews(videos[prevVideo].shorts_id);
        }
    };

    const handleEdifiedState = async(shortVidId)=>{
        await initDB();
        const data = await getEdifiedStateDB(shortVidId);
        if(data?.shID && data?.shID === shortVidId){
            setEdified(true);
        }else{
            setEdified(false);
        }
    };

    const handleShortVidViews=async(shortsVidId)=>{
        try {
            await initDB();
            const data = getViewsDB(shortsVidId);
            if(data == null || data === "undefined"){
                const res = await trackshortViewsDB({id: shortsVidId,viewID: shortsVidId});
                if(res === true){
                    var viewsSnapshot = await get(ref(realTimeDB,`shortsVideos/${shortsVidId}/views`));
                    if(viewsSnapshot.exists()){
                        if(viewsSnapshot.val() == null || viewsSnapshot.val() === 0){
                            set(ref(realTimeDB,`shortsVideos/${shortsVidId}/views`), 1);
                        }else{
                            set(ref(realTimeDB,`shortsVideos/${shortsVidId}/views`), viewsSnapshot.val() + 1);
                        }
                        
                    }else{
                        set(ref(realTimeDB,`shortsVideos/${shortsVidId}/views`), 1);
                    }
                }
            }
        } catch (error) {
            console.log(error)
        }
    };

    const handlePlayerClicked=()=>{
        setPlaying(prev => !prev);
    };
    const handleEnded=()=>{
        setPlaying(false);
    };
    const onBuffering=()=>{
        setBuffering(true);
    };
    const onBufferEnd=()=>{
        setBuffering(false);
    };

    const handleEdified=async()=>{
        try {
            await initDB();
            const res = await trackEdifiedStateDB({id: videoUrl.shortsid, shID: videoUrl.shortsid});
            if(res === true){
                var countEdified = await get(ref(realTimeDB,`shortsVideos/${videoUrl.shortsid}/edified`));
                if(countEdified.exists()){
                    if(countEdified.val() == null || countEdified.val() === 0){
                        set(ref(realTimeDB,`shortsVideos/${videoUrl.shortsid}/edified`), 1);
                    }else{
                        set(ref(realTimeDB,`shortsVideos/${videoUrl.shortsid}/edified`), countEdified.val() + 1);
                    }
                }else{
                    set(ref(realTimeDB,`shortsVideos/${videoUrl.shortsid}/edified`), 1);
                }
                onValue(ref(realTimeDB,`shortsVideos/${videoUrl.shortsid}/edified`),(snapshot)=>{
                    if(snapshot.exists()){
                        setLikes(snapshot.val());
                    }
                });
                setEdified(true);
            }
            
        } catch (error) {
            console.log(error);
        }
    };

    const removeEdified=async()=>{
        try {
            await initDB();
            const res = await trackEdifiedStateDB({id: videoUrl.shortsid,shID: ""});
            if(res === true){
                var countEdified = await get(ref(realTimeDB,`shortsVideos/${videoUrl.shortsid}/edified`));
                if(countEdified.exists()){
                    if(countEdified.val() !== null && countEdified.val() !== 0){
                        set(ref(realTimeDB,`shortsVideos/${videoUrl.shortsid}/edified`), countEdified.val() - 1);
                    }else{
                        set(ref(realTimeDB,`shortsVideos/${videoUrl.shortsid}/edified`), 0);
                    }  
        
                    onValue(ref(realTimeDB,`shortsVideos/${videoUrl.shortsid}/edified`),(snapshot)=>{
                        if(snapshot.exists()){
                            setLikes(snapshot.val());
                        }
                        });
                        setEdified(false);
                }
            }
        } catch (error) {
            
        }
    };

    const handleCopyLink=async()=>{
        if(navigator.clipboard){
            try{
                await navigator.clipboard.writeText(`https://horemowbookreaderlite.web.app/${videoUrl.shortsid}`);
                setCopied(true);

                const snapshot = await get(ref(realTimeDB,`shortsVideos/${videoUrl.shortsid}/shares`));
                if(snapshot.exists()){
                    if(snapshot.val() == null || snapshot.val() === 0){
                        set(ref(realTimeDB,`shortsVideos/${videoUrl.shortsid}/shares`), 1);
                    }else{
                        set(ref(realTimeDB,`shortsVideos/${videoUrl.shortsid}/shares`), snapshot.val() + 1);
                    }
                    
                }else{
                    set(ref(realTimeDB,`shortsVideos/${videoUrl.shortsid}/shares`), 1);
                }
            }catch{
            }
        }
    };

    const handleMoreOptions=async()=>{
        if(navigator.share){
            setShare(false);
            try{
                await navigator.share({
                    text: `Divine shorts (video) by ${videoUrl.name}\n\n`,
                    url:`https://horemowbookreaderlite.web.app/${videoUrl.shortsid}`
                });
            }catch{
            }
        }
    };

    useEffect(()=>{
        if(copied){
            const timeid = setTimeout(() => {
                setCopied(false);
                setShare(false);
           }, 2000);

           return ()=>{
            clearTimeout(timeid);
           }
        }
    },[copied]);

    const handleReport=()=>{
        navigate("/contact", {state: {from: location.pathname}});
    };

    useEffect(()=>{
        if(share){
            const handleCloseShare =(e)=>{
                if(!closeShareRef.current.contains(e.target)){
                    setShare(false);
                }
            }
            document.addEventListener('mousedown',handleCloseShare);
            
            return()=>{
                document.removeEventListener('mousedown',handleCloseShare);
            }
        }
    },[share]);

    useEffect(()=>{
        if(openMenu){
            const handleCloseMenu =(e)=>{
                if(!closeMenuRef.current.contains(e.target)){
                    setOpenMenu(false);
                }
            }
            document.addEventListener('mousedown',handleCloseMenu);
            
            return()=>{
                document.removeEventListener('mousedown',handleCloseMenu);
            }
        }
    },[openMenu]);

    const handleDeleteVideo=async()=>{
        try {
            dispatch({type: actionConsts.PROGRESSINDICATOR, payload: true});
            const videoPath = storageRef(storage,`shorts_video/${videoUrl.shortsid}`);
            await deleteObject(videoPath);
            const videoThumbPath = storageRef(storage,`shorts_thumb/${videoUrl.shortsid}`);
            await deleteObject(videoThumbPath)
            const doc_ref = doc(db,`shorts`,videoUrl.shortsid);
            await deleteDoc(doc_ref);
            remove(ref(realTimeDB,`shortsVideos/${videoUrl.shortsid}`));
            dispatch({type: actionConsts.PROGRESSINDICATOR, payload: false});
            setOpenMenu(false);
            handleChangeVideo("next");
        } catch (error) {
            dispatch({type: actionConsts.PROGRESSINDICATOR, payload: false});
            console.log(error);
        }
    };

    const handleComments=()=>{
        dispatch({type: actionConsts.ALERT_MESSAGE, payload: "Comment section is under development"});
        dispatch({type: actionConsts.SHOWALERT, payload: true});
    };

    const handleCloseAlert=useCallback((data)=>{
        if(data === "close"){
            dispatch({type: actionConsts.SHOWALERT, payload: false});
        }
    },[]);

    const handleClosePage=()=>{
        if (location.state && location.state.from) {
            navigate(location.state.from);
        }else{
            navigate("/");
        }
    };

    const handleVideoMute=(actionType)=>{
        if (actionType === "mute") {
            dispatch({type: actionConsts.MUTE, payload: true});
        }else if (actionType === "unmute") {
            dispatch({type: actionConsts.MUTE, payload: false});   
        }
    };




    return videoUrl.vid && videoUrl.vid !== "" && ( 
        <div className="viewshortslayout">
            {state.showAlert && 
                  <CustomAlertDialog alertmessage={state.alertMessage} handleCloseDialog={handleCloseAlert}/>
            }

            {videoUrl.i >= 1 && 
                <button id="shortsPlayerBtnarrow" onClick={()=>handleChangeVideo("prev")}>
                    <ArrowBackIos/>
                </button>
            }

            <div className="shortsplayervidscreen" onClick={()=>handlePlayerClicked()}>
                        <ReactPlayer
                            onEnded={handleEnded}
                            playing={playing}
                            muted={state.mute}
                            onBuffer={onBuffering}
                            onBufferEnd={onBufferEnd}
                            width="100%"
                            height="100%"
                            url={videoUrl.vid}
                            />
            </div>

            <button id="shortsPlayerBtnarrow" onClick={()=>handleChangeVideo("next")} >
                <ArrowForwardIos/>
            </button>

            <section className="shortsplayerTop flex-spacearound">
                <div className="hbrbrandonplayer flex-row2">
                    <img src={appIcon} alt="" style={{width:"2.5em",height:"2.5em",borderRadius:"50%",objectFit:"cover"}}/>
                    <h4 style={{color:"teal"}}>Sho<span style={{color:"#eb268f"}}>rts</span></h4>
                </div>

                {width <= 1110 ? 
                    <div className="uploaderinfo-phone flex-column1">
                        <div className="flex-row2">
                                {videoUrl.profilepic !== "" ? 
                                    (<img src={videoUrl.profilepic} alt="" style={{width:"2.2em",height:"2.2em",borderRadius:"50%",objectFit:"cover"}}/>)
                                    :
                                    (<HbrAvatarProfile width="2.2em" height="2.2em" />)
                                }
                                <div className="flex-column2">
                                    <h4 style={{color:"white",fontWeight:"bold", fontSize:"small"}}>{videoUrl.name}</h4>
                                    <h5 style={{color:"white",fontWeight:"bolder"}}>{FormatTimePassedUtc(videoUrl.vidDate)}</h5>
                                </div>
                        </div>

                        {videoUrl.desc && 
                            <footer className="desclayout-phone">
                                <TextShortener fullText={videoUrl.desc} words={4} toggleButtonColor={"white"}/>
                            </footer> 
                        }
                    </div>
                    :
                    <div className="uploaderinfo flex-spacebetween">
                        <div className="flex-row2">
                                {videoUrl.profilepic !== "" ? 
                                    (<img src={videoUrl.profilepic} alt="" style={{width:"2.2em",height:"2.2em",borderRadius:"50%",objectFit:"cover"}}/>)
                                    :
                                    (<HbrAvatarProfile width="2.2em" height="2.2em" />)
                                }
                                <div className="flex-column2">
                                    <h4 style={{color:"white"}}>{videoUrl.name}</h4>
                                    <h5 style={{color:"white",fontWeight:"bold"}}>{FormatTimePassedUtc(videoUrl.vidDate)}</h5>
                                </div>
                        </div>

                        <div className="videoplaypausebtnandmenu flex-row2" style={{gap:"10px"}}>
                            {state.mute ? (<HbrSoundOff width="2em" height="2em" fillColour="#ffffff" handleClick={()=>handleVideoMute("unmute")}/>) 
                                : (<HbrSoundOn width="2.5em" height="2.5em" fillColour="#ffffff" handleClick={()=>handleVideoMute("mute")}/>)
                            }

                            {!playing ?
                            (<HbrPlayButton width="2em" height="2em" fillColour="#ffffff" handleClick={()=>handlePlayerClicked()}/>)
                                :
                            (<HbrStopPlayback width="2em" height="2em" fillColour="#ffffff" handleClick={()=>handlePlayerClicked()}/>)
                            }

                            <div>
                                <h4 style={{color:"white",fontWeight:"bold"}}>
                                    {`${Number(videoUrl.i) + Number(2)}/${videos?.length + 1}`}
                                </h4>
                            </div>
                        </div>
                    </div>
                }
            

                <div className="myprofileandclosebtn flex-row2">
                        {profile_pic && profile_pic !== "" ? 
                            (<img src={profile_pic} alt="" style={{width:"2.2em",height:"2.2em",borderRadius:"50%",objectFit:"cover"}}/>)
                            :
                            (<HbrAvatarProfile width="2.2em" height="2.2em" />)
                        }

                        {width <= 600 &&
                            <div>
                                { state.mute ? (<HbrSoundOff width="1.8em" height="1.8em" fillColour="#ffffff" handleClick={()=>handleVideoMute("unmute")}/>) 
                                : (<HbrSoundOn width="2em" height="2em" fillColour="#ffffff" handleClick={()=>handleVideoMute("mute")}/>)}
                            </div>
                        }
                        {width <= 600 &&
                            <div>
                                {!playing ?
                                (<HbrPlayButton width="2em" height="2em" fillColour="#ffffff" handleClick={()=>handlePlayerClicked()}/>)
                                    :
                                (<HbrStopPlayback width="2em" height="2em" fillColour="#ffffff" handleClick={()=>handlePlayerClicked()}/>)
                                }
                            </div>
                        }

                        <div>
                        <HbrCancel width={"2em"} height={"2em"} fillColour={"#ffffff"} handleClick={()=>handleClosePage()}/>
                        </div>
                </div>
            </section>

            {buffering && 
            <div style={{position:"absolute",top:"50%",left:"45%"}} className="shortsLoader"></div>
            }
        
            {width <= 1110 &&
                <div className="shortplayerphonebtn flex-row2">
                    {videoUrl.i >= 1 && 
                         <div className="shortsplayervidchanger">
                         <HbrArrowLeft width={"2em"} height={"2em"} fillColour={"#ffffff"} handleClick={()=>handleChangeVideo("prev")}/>
                        </div>
                    }
                    
                    <div className="shortsplayervidchanger">
                        <HbrArrowRight width={"2em"} height={"2em"} fillColour={"#ffffff"} handleClick={()=>handleChangeVideo("next")}/>
                    </div>

                    <div style={{backgroundColor:"#10101050", borderRadius:"30px"}}>
                        <h4 style={{color:"white",fontWeight:"bold", padding:"8px"}}>
                                        {`${Number(videoUrl.i) + Number(2)}/${videos?.length + 1}`}
                        </h4>
                    </div>
                
                </div>  
            
            }
    
            {width >=1110 && videoUrl?.desc && 
                <footer className="desclayout">
                    <TextShortener fullText={videoUrl.desc} words={15} toggleButtonColor={"white"}/>
                </footer> 
            }

            <div className="shortsvidreactbuttons flex-column2">

                    <div className="flex-column2">
                        <h4 style={{color:"white",fontWeight:"bold"}}>Views</h4>
                        <h5 style={{color:"white",fontWeight:"bold"}}>{views && views}</h5>
                    </div>                     

                    <div className="flex-column2">
                        {edified ?  
                        <img src={edifiedred} alt="" onClick={()=>removeEdified()}/> 
                            :
                        <img src={edifiedBtn} alt="" onClick={()=>handleEdified()}/>
                        }
                        {likes !== 0 &&
                        <h5 style={{color:"white",fontWeight:"bold"}}>{`${likes} edified`}</h5>
                        }
                    </div>
        
                    <div style={{position:"relative"}}>
                        <div className="flex-column2">
                            <HbrForwardIcon width={"2.2em"} height={"2.2em"} fillColour={"white"} handleClick={() => setShare(true)}/>
                            {shareCount > 0 &&
                                <div>
                                    <h5 style={{color:"white",fontWeight:"bold"}}>{`${shareCount === 1 ? shareCount + ' share' :  shareCount + ' shares'}`}</h5>
                                </div>
                            }
                    </div>
                    
                    {share && 
                        <div className="shareform flex-column2" ref={closeShareRef}>

                                <div className="flex-spacebetween" style={{width:"100%",background:"#00000010"}}> 
                                    <h4 style={{width:"80%",overflow:"hidden", color:"white"}}>
                                        {`https://horemowbookreaderlite.web.app/divineshorts/${videoUrl.shortsid}`}
                                    </h4>
                                    <HbrIconFileCopy width={"2em"} height={"2em"} fillColour={"white"} handleClick={()=>handleCopyLink(videoUrl.shortsid)}/>
                                </div>

                                <div className="flex-row2">
                                    <h4 style={{color:"white"}}>More options</h4>
                                    <HbrShareIcon width={"2em"} height={"2em"} fillColour={"white"} handleClick={()=>handleMoreOptions()}/>
                                </div>
                        </div>
                    }
                    
                    </div>

                    <div onClick={()=>handleComments()}>
                        <HbrCommentIcon width="2em" height="2em" fillColour="#ffffff" />
                    </div>

                    <div style={{position:"relative"}}>
                        <HbrMoreHorizontal width="2em" height="2em" fillColour="#ffffff" handleClick={()=>setOpenMenu(prev => !prev)}/> 

                        {openMenu && 
                                
                            <div className="shortsvidmenu flex-column2" ref={closeMenuRef}>
                                    {videoUrl.email === user_email && 
                                        <button 
                                            onClick={()=>handleDeleteVideo()}
                                            style={{border:"none",backgroundColor:"transparent",padding:"5px",cursor:"pointer",fontWeight:"bold",color:"red"}}>
                                                Delete <Delete/>
                                        </button>
                                    }

                                    <button 
                                        onClick={()=>handleReport()}
                                        style={{border:"none",backgroundColor:"transparent",padding:"10px",cursor:"pointer",fontWeight:"bold"}}>
                                            Report as inappropriate<HbrFlagReport width={"2em"} height={"2em"} fillColour={"#000000"}/>
                                    </button>

                            </div>
                        }
                    
                    </div>
                
            </div>

            {state.progressIndicator && 
                <div style={{
                    position:"absolute",
                    top:"50%",
                    left:"45%",
                    border: "5px solid black",
                    borderBottom: "5px solid white",
                    borderTop: "5px solid white",
                    borderRadius: "50%",
                    animation: "spin2 2s linear infinite",
                    backgroundColor: "#00000080"
                    }}>
                        <HbrBrushIcon width="2em" height="2em" fillColour="#ffffff"/>
                </div>
            }

    </div>
     );
}
export default ShortVideoPlayer;